import styled from 'styled-components';

export const WaterMark = styled.div`
  position: absolute;
  font-size: 5rem;
  inset: 0px;
  color: rgba(0, 0, 0, 0.1);
  pointer-events: none;
  user-select: none;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 210mm;
  min-height: 297mm;
  color: #000;
  background-color: #fff !important;
  font-size: 16px;
  line-height: 1.4;
  margin: 0 auto;

  @page {
    margin: 0;
  }

  @media print {
    @page {
      margin: 0;
      padding: 0;
    }

    width: 100%;
    height: 100vh;
    min-height: 297mm;
    font-size: 18px;

    * {
      box-sizing: border-box;
    }

    body {
      margin: 0;
      padding: 0;
    }
  }
`;

export const BarraTop = styled.div`
  width: 100%;
  height: 30px;
  backgroundcolor: rgb(248 0 63);
`;

export const Label = styled.p`
  font-weight: bold;
  margin-bottom: 0;
`;

export const InstructionBox = styled.div`
  background-color: rgb(197 197 197);
  border-radius: 20px;
  padding: 10px;
  margin-top: 10px;
  width: 300px;
  height: 220px;
`;

export const InstructionHeader = styled.div`
  display: flex;
  gap: 2px;
  justify-content: space-between;
`;

export const InstructionContent = styled.div`
  font-size: 0.65rem;
  margin-top: 4px;

  div {
    margin-bottom: 6px;
  }
`;

export const InstructionItem = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const InstructionCircle = styled.div`
  padding: 8px 12px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #b4adad;
`;

export const PatientContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

export const PatientData = styled.div`
  display: flex;
  gap: 6px;
  justify-content: space-between;
  margin-top: 2px;
`;

export const Separador = styled.hr`
  margin: 0 0 10px 0;
  border-bottom: 1px solid #ccc;
`;

export const Section = styled.div`
  padding: 0 10mm;
  margin-top: 20px;
  page-break-inside: avoid;
  position: relative;
  z-index: 1;
`;

export const SectionTitle = styled.p`
  margin: 0 0 10px 0;
  font-weight: bold;
  text-transform: uppercase;
  color: #333;
  border-bottom: 1px solid #ccc;
  padding-bottom: 3px;
  letter-spacing: 1px;
`;

export const MedicamentObservation = styled.span`
  font-size: 14px;
`;

export const ObservacoesSection = styled.div`
  margin-top: 15px;
  padding: 10px;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 4px;
  page-break-inside: avoid;
  position: relative;
  z-index: 1;

  p {
    font-size: 15px;
    line-height: 1.5;
  }
`;

export const SignatureSection = styled.div`
  // height: 25mm;
  flex-shrink: 0;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SignatureLine = styled.div`
  width: 280px;
  border-top: 2px solid #3d3d3d;
  margin-bottom: 5px;
`;

export const SignatureInfo = styled.div`
  width: 100%;
  text-align: center;
  color: #333;
  font-weight: bold;

  span {
    font-weight: normal;
    margin-left: 8px;
  }
`;

export const ControladoBadge = styled.span<{ controlado: boolean }>`
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  background-color: ${props => (props.controlado ? '#fff3cd' : '#e2e3e5')};
  color: ${props => (props.controlado ? '#856404' : '#383d41')};
  border: 1px solid ${props => (props.controlado ? '#ffeeba' : '#d6d8db')};
`;

/** *** Controle especial   ***** */

export const BuyerContent = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 80px;
  padding: 0 10mm;

  div {
    flex: 1;
    padding: 10px;
    border: 1px solid #000;
    max-width: 410px;
  }
`;

export const IssuerContent = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto 14px auto;
  text-align: center;
`;

export const IssuerTitle = styled.p`
  font-size: 20px;
  font-weight: bold;
`;
